import React, { FC } from 'react'
import {
    ButtonContainer,
    ButtonText,
    FeaturesWrapper,
    ImageContainer,
    SelectButton,
    SelectContainer,
    SelectedIcon,
    UnitCardContainer,
    UnitDetails,
    UnitDetailsSubcontainer,
    UnitTitle,
    ViewMore,
} from './object-styles'
import StatsBar from '../common/stats/stats'
import InlineFeatures from '../common/features/features'
import { Typography } from 'react-components'
import { useTranslation } from '../../../../hooks/locale'
import { FormattedPropertyData } from '../../../../models/property-details-page/property-details-model'
import PulsatingDots from '../../pulsating-dots'

type MobileObjectProps = {
    data: FormattedPropertyData
    onClick?: () => void
    price: string
    isPriceLoading: boolean
    isSelected: boolean
    onChangeIndex: () => void
    isSidebarLoading: boolean
}

const ObjectMobile: FC<MobileObjectProps> = ({
    data,
    onClick,
    price,
    isPriceLoading = false,
    isSelected,
    onChangeIndex,
    isSidebarLoading,
}) => {
    const { t } = useTranslation()
    return (
        <UnitCardContainer onClick={onClick}>
            <UnitDetails>
                <UnitDetailsSubcontainer>
                    <UnitTitle>{data.title}</UnitTitle>
                    <StatsBar shouldDisplayAll={false} stats={data.stats}></StatsBar>
                    <FeaturesWrapper>
                        <InlineFeatures features={data.features} color="#141414" size={1} gap={1} visibleFeatures={4} />
                    </FeaturesWrapper>
                </UnitDetailsSubcontainer>
                {data.gallery.length > 0 && <ImageContainer src={data.gallery[0].thumbnail} />}
            </UnitDetails>
            <SelectContainer>
                {isPriceLoading ? (
                    <PulsatingDots />
                ) : (
                    <Typography variant="subtitle1" fontWeight={600} lineHeight={1.375} whiteSpace="nowrap">
                        {price}
                    </Typography>
                )}
                <ButtonContainer>
                    <SelectButton
                        isSelected={isSelected}
                        onClick={e => {
                            e.stopPropagation()
                            onChangeIndex()
                        }}
                    >
                        {isSelected && <SelectedIcon></SelectedIcon>}
                        <ButtonText>
                            <Typography variant="subtitle2" lineHeight={1.5} fontWeight={600}>
                                {isSelected ? t('entitySection.selected') : t('entitySection.select')}
                            </Typography>
                        </ButtonText>
                    </SelectButton>
                    <ViewMore>
                        <Typography variant="subtitle2" fontWeight={'regular'}>
                            {isSidebarLoading ? <PulsatingDots /> : t('entitySection.viewDetails')}
                        </Typography>
                    </ViewMore>
                </ButtonContainer>
            </SelectContainer>
        </UnitCardContainer>
    )
}

export default ObjectMobile
